// overview/* 페이지 번역
const overview = {
  enterpriseFactory: {
    v2: {
      breadcrumbRoot: '전사',
      refresh: '새로 고침',
      retry: '다시 시도',
      loadFailed: '공장 현황을 불러오지 못했습니다',
      loading: '불러오는 중...',
      empty: '등록된 공장이 없습니다',
      unitMachine: '대',
      unitCase: '건',
      unitCount: '개',
      level: {
        good: '정상',
        warn: '경고',
        bad: '위험',
      },
      status: {
        running: '가동',
        idle: '대기',
        stopped: '정지',
        partial: '일부 정지',
        none: '설비 없음',
      },
      kpi: {
        equipment: '전체 설비 수',
        rate: '전체 가동률',
        rateSub: '가동 {r} · 대기 {i} · 정지 {s}',
        alarms: '전체 알람',
        alarmSub: '위험 {c} · 경고 {w} · 정보 {i}',
        production: '전체 생산량 (오늘)',
        productionSub: '단위: 샷',
      },
      openFactory: '공장 사출 현황 열기',
      runShare: '가동 비율',
      legend: {
        running: '가동',
        idle: '대기',
        stopped: '정지',
      },
      rate: '가동률',
      equipment: '설비 수',
      openAlarms: '미처리 알람',
      machinesTitle: '설비 현황',
      noMachines: '등록된 설비가 없습니다',
      moldNo: '금형번호',
      shotCount: '샷카운트',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      alarmCount: '알람 {n}건',
      cycle: '사이클',
      alarmsTitle: '실시간 알람',
      filter: {
        all: '전체',
        error: '위험',
        warning: '경고',
      },
      noAlarms: '진행중인 알람이 없습니다.',
      repeat: '24시간 {n}회 · {time}',
    },
  },
  factoryDefect: {
    breadcrumbRoot: '전사',
    pageLabel: '불량 이력',
    panelTitle: '공장 불량 이력 · 사출기 {n}대',
    refresh: '새로 고침',
    loadingData: '불러오는 중...',
    loadFailed: '불량 이력을 불러오지 못했습니다',
    factoryListLoadFailed: '공장 목록을 불러오지 못했습니다',
    period: '기간',
    periods: { today: '오늘', yesterday: '어제', last24h: '최근 24시간', last48h: '최근 2일' },
    source: '판정 기준',
    sources: { fusion: '융합검사', vision: '비전검사', process: '공정검사' },
    equipment: '설비',
    type: '유형',
    all: '전체',
    allEquipment: '전체 설비',
    retentionNote: '샷·판정 결과는 최근 2일 보관',
    kpi: { inspected: '검사 샷', ng: '불량', ngRate: '불량률', topType: '최다 유형', topEquipment: '최다 불량 설비' },
    countN: '{n}건',
    matrixTitle: '설비 × 불량 유형',
    matrixSub: '판정 결과 있는 설비 {n} / {total}대 · 칸을 누르면 아래가 걸러집니다',
    trendTitleHour: '시간대별 불량 추이',
    trendTitleDay: '일별 불량 추이',
    noTrend: '이 기간에 판정 결과가 없습니다',
    listTitle: '불량 목록',
    rowHint: '누르면 이 사출기의 품질·생산 화면으로 이동합니다',
    empty: '이 기간에 판정 결과가 없습니다',
    emptyFiltered: '조건에 맞는 불량이 없습니다',
    colEquipment: '설비',
    colTotal: '합계',
    colRate: '불량률',
    colTime: '시각',
    colMold: '금형',
    colShot: '샷',
    colType: '유형',
    colProcess: '공정 점수',
    colVision: '비전 점수',
    colFusion: '융합 점수',
    colImage: '이미지',
    types: { FLASH: '플래시(버)', WELDLINE: '웰드라인', SHORT: '미성형', SINK: '수축(싱크)', PROCESS: '공정 기인', UNKNOWN: '기타' },
    prev: '이전',
    next: '다음',
  },
  factoryMachine: {
    breadcrumbRoot: '전사',
    pageLabel: '사출기 현황',
    panelTitle: '공장내 사출기별 현황 · {n}대',
    cards: {
      line: '라인',
      state: '상태',
      sort: '정렬',
      alarmOnly: '알람',
      moldNo: '금형번호',
      shotCount: '샷카운트',
      cav: 'CAV', // 캐비티 수 — 현장 약어 그대로
      ct: 'C/T', // 사이클 타임 — 현장 약어 그대로
      utilization: '가동률',
      cycleTime: '사이클',
      alarmCount: '알람 {n}건',
      sort_utilization: '가동률↓',
      sort_number: '번호순',
      sort_shot: '샷카운트↓',
      sort_alarm: '알람 우선',
    },
    title: '사출기별 대시보드',
    subtitle: '공장내 사출기 현황',
    update: '업데이트',
    loading: '로딩 중...',
    loadingData: '데이터를 불러오는 중...',
    loadFailed: '데이터를 불러오는데 실패했습니다.',
    factoryListLoadFailed: '공장 목록을 불러오는데 실패했습니다.',
    refresh: '새로고침',
    emptyMachines: '등록된 사출기가 없습니다.',
    selectFactory: '공장을 선택하세요',
    all: '전체',
    machine: {
      productName: '제품명',
      shotCount: '샷카운트',
      cavityCount: '캐비티수',
      cycleTime: '사이클타임',
      utilizationLabel: '24시간 가동률',
      timelineTitle: '24시간 가동상태',
      cavityUnit: '{n}개',
      cycleTimeUnit: '{n}s',
      empty: '-',
    },
    legend: {
      operating: '가동',
      standby: '대기',
      stopped: '정지',
    },
    status: {
      running: '가동중',
      idle: '대기',
      stopped: '정지',
      error: '오류',
    },
  },
};

export default overview;
